import VueSweetalert2 from 'vue-sweetalert2'
import Vue from 'vue'
Vue.use(VueSweetalert2)
